import * as R from 'ramda';
import { MassActionCombinationItem, MassActionCombinationItemsById } from '../productDetails.types';

export const buildMassActionCombinationKey = ({
  orderId,
  productColorId,
  availability,
  deliveryWindowId,
}: MassActionCombinationItem): string =>
  `${orderId}|${productColorId}|${availability}|${deliveryWindowId ?? ''}`;

export const toggleItemToPasteGrid = (
  item: MassActionCombinationItem,
  itemsById: MassActionCombinationItemsById,
): MassActionCombinationItemsById => {
  const combinationKey = buildMassActionCombinationKey(item);

  if (itemsById[combinationKey]) {
    return R.omit([combinationKey], itemsById);
  }

  return { ...itemsById, [combinationKey]: item };
};
